export const DataTypes = {
  Date: 'Date',
  Number: 'Number',
  Text: 'Text',
};
